import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import * as moment from 'moment';
import { AttendanceCode } from '../../../../classroom360/attendance/models/attendance-code.model';
import { SharedService } from '../../../../shared-components/shared.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { take } from 'rxjs/operators';
import { SchoolSettingsAttendanceService } from '../../../../management360/school/school-settings-attendance/school-settings-attendance.service';
import { Student } from '../../../../shared-components/student/student.model';
import { StudentSearchComponent } from '../../../../shared-components/student-search/student-search.component';
import { School } from '../../../../shared-components/year/school.model';
import { AttendanceByStudentComponent } from '../../attendance-by-student/attendance-by-student.component';
import { CheckInOutSettings } from '../../attendance-check-in-out/attendance-check-in-out.model';
import { System } from '../../../../shared-components/System';

@Component({
  selector: 'app-check-in-out-modal-dialog',
  templateUrl: './check-in-out-modal-dialog.component.html',
  styleUrls: ['./check-in-out-modal-dialog.component.css']
})
export class CheckInOutModalDialogComponent implements OnInit {
  type = '';
  attendanceDate: Date;
  errors: ErrorList[] = [];
  checkInOutTime = '';
  overwriteAttendanceCodes = true;
  attendanceCodes: AttendanceCode[] = [];
  selectedAttendanceCode = '';
  dailyPeriodComment = '';
  updatePeriodComment = false;
  periodComment = 'A';
  updateDailyComment = true;
  dailyComment = 'A';
  selectedStudent: Student[] = [];
  schools: School[] = [];
  checkInOutSettings: CheckInOutSettings;

  timeField: ElementRef;
  timeRegexp = System.twelveHourTimeRegexp;
  @ViewChild('periodCode', { read: ElementRef }) periodCodeRef: ElementRef;

  constructor(private dialogRef: MatDialogRef<CheckInOutModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private yearService: YearService,
    private schoolSettingService: SchoolSettingsAttendanceService) { }

  ngOnInit() {
    this.getSchoolSettingsAttendace();
    this.getAttendanceCodes();
    this.type = this.data.type;
    this.attendanceDate = this.data.attendanceDate;
    this.selectedStudent = this.data.selectedStudent;
    const time = new Date();
    this.checkInOutTime = moment(time.toString()).format('hh:mm a').toUpperCase();

    if (this.data.checkInOutSettings != undefined) {
      this.checkInOutSettings = this.data.checkInOutSettings;
      this.type = this.checkInOutSettings.Type;
      this.checkInOutTime = this.checkInOutSettings.Time;
      this.selectedAttendanceCode = this.checkInOutSettings.PriorPeriodCodeId;
      this.overwriteAttendanceCodes = this.checkInOutSettings.OverwriteExistingAttendanceCode;
      this.dailyPeriodComment = this.checkInOutSettings.DailyComment;
      this.updatePeriodComment = this.checkInOutSettings.UpdatePeriodComment;
      this.periodComment = this.checkInOutSettings.PeriodCommentAppOROver;
      this.updateDailyComment = this.checkInOutSettings.UpdateDailyComment;
      this.dailyComment = this.checkInOutSettings.DailyCommentAppOROver;
    }
  }

  cancelClick() {
    this.dialogRef.close();
  }

  getAttendanceCodes() {
    this.sharedService.getAttendanceCodeLookup(false, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id).pipe(take(1)).subscribe(codes => {
      this.attendanceCodes = codes;
    });
  }

  getSchoolSettingsAttendace() {
    this.schoolSettingService.getSchoolSettingsAttendanceOptions().pipe(take(1)).subscribe(setting => {
      this.selectedAttendanceCode = setting[0].FullPeriodAbsenceCode.toString();
    });
  }

  setToDefault() {
    this.dailyPeriodComment = this.type + ' at ' + this.checkInOutTime;
  }

  previousClick() {
    this.errors = [];
    this.dialogRef.close();
    const dialogRef = this.dialog.open(StudentSearchComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      data: {
        performRoute: false,
        searchAndSelect: true,
        returnSelectedStudents: true,
        viewAllStudentsInThisSchoolYear: false,
        selectedStudents: this.selectedStudent,
        headerMessage: 'Step 1 of 3 - Select Students',
        schools: this.schools,
        hideSaveButton: true,
        showLargeHeaderMessage: true
      },
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((returnedStudents: Student[]) => {
      if (returnedStudents && returnedStudents instanceof Array) {
        const checkInOutDialogRef = this.dialog.open(CheckInOutModalDialogComponent, {
          disableClose: true,
          data: {
            selectedStudent: returnedStudents,
            type: this.type,
            attendanceDate: this.attendanceDate
          },
          minWidth: '40vw',
          maxWidth: '40vw',
          minHeight: '90vh',
          maxHeight: '90vh'
        });
      }
    });
  }

  nextclick() {
    this.errors = [];
    if (this.checkInOutTime == undefined || this.checkInOutTime == null || this.checkInOutTime == '') {
      this.errors.push({
        fieldName: 'Time',
        fieldRef: this.timeField,
        errorMsg: ' is required.'
      });
    }

    if (this.checkInOutTime != undefined && this.checkInOutTime != '' && !this.checkInOutTime.match(this.timeRegexp)) {
      this.errors.push({
        fieldName: 'Time',
        fieldRef: this.timeField,
        errorMsg: ' Must be in time format, hh:mm [AM|PM].'
      });
    }

    if (this.selectedAttendanceCode == undefined || this.selectedAttendanceCode == '') {
      this.errors.push({
        fieldName: 'Periods Code',
        fieldRef: this.periodCodeRef,
        errorMsg: ' is required.'
      });
    }

    if (this.errors.length == 0) {
      this.checkInOutSettings = new CheckInOutSettings;
      this.checkInOutSettings.Type = this.type;
      this.checkInOutSettings.Time = this.checkInOutTime;
      this.checkInOutSettings.PriorPeriodCodeId = this.selectedAttendanceCode;
      this.checkInOutSettings.OverwriteExistingAttendanceCode = this.overwriteAttendanceCodes;
      this.checkInOutSettings.DailyComment = this.dailyPeriodComment == '' ? this.type + ' at ' + this.checkInOutTime : this.dailyPeriodComment;
      this.checkInOutSettings.UpdatePeriodComment = this.updatePeriodComment;
      this.checkInOutSettings.PeriodCommentAppOROver = this.periodComment;
      this.checkInOutSettings.UpdateDailyComment = this.updateDailyComment;
      this.checkInOutSettings.DailyCommentAppOROver = this.dailyComment;
      this.dialogRef.close();

      const attendanceByStudentDialog = this.dialog.open(AttendanceByStudentComponent, {
        data: {
          calledAsDialog: true,
          selectedStudents: this.selectedStudent,
          attendanceDate: this.attendanceDate,
          checkInOutSettings: this.checkInOutSettings,
          calledFromCheckInOut: true
        },
        disableClose: true,
        minWidth: '90vw',
        maxWidth: '90vw',
        minHeight: '90vh',
        maxHeight: '90vh'
      });
    }
  }

}
